/**
 * String canônica assinada. DEVE ser byte-a-byte igual ao backend:
 * método \n urlComParams \n bodyHash \n timestamp \n nonce
 */
export function buildCanonical(
  method: string,
  urlWithParams: string,
  timestamp: number,
  nonce: string
): string {
  return [method.toUpperCase(), urlWithParams, String(timestamp), nonce].join('\n');
}
